import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import { classWithModifiers } from '~/react/componentHelper';
import { primeOrder } from '~/config/editions/ClientSafeEditions';
import IndicatorIcon from '~/public/assets/icons/icon_indicator.svg';
import { setLinkCetDataVars } from '~/server/utils/cetTrackingHelper';

defineMessages({
  EDITIONS_MENU_LABEL: {
    id: 'EDITIONS_MENU_LABEL',
    description: 'Label to change the site edition. E.g. U.K Edition, U.S. Edition, Italia Edizione',
    defaultMessage: '{editionName} Edition',
  },
});

class EditionsMenu extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectable: this.props.selectable,
      showOptions: false,
    };
    this.handleToggleOptions = this.handleToggleOptions.bind(this);
  }

  handleToggleOptions() {
    this.setState({ showOptions: !this.state.showOptions });
  }

  render() {
    const { modifiers, editionInfo, enabledCET } = this.props;
    const { selectable, showOptions } = this.state;

    let className = classWithModifiers('editions-menu', modifiers);
    className += selectable ? ` ${className}--selectable ${enabledCET ? 'enableCET' : ''}` : '';
    const activeEditions = primeOrder.filter((edition) => edition.active && !edition.excludeFromNav);
    const editionsList = activeEditions.map((edition, key) => {
      let cetData = {};
      if (enabledCET) {
        cetData = setLinkCetDataVars('nav_bar', edition.link, edition.name, 'text', 'site_header');
        cetData = {
          ...cetData,
          ...{
            'data-vars-position-in-subunit': key + 1, // open/close button has position 0
            'data-vars-subunit-name': 'edition_nav',
            'data-vars-subunit-type': 'component',
          },
        };
      }

      return (edition.id === editionInfo.id
        ? (
          <div
            key={edition.id}
            className={classWithModifiers('editions-menu__list__item', ['current'])}
            {...cetData}
          >
            {edition.name}
          </div>
        )
        : (
          <a
            key={edition.id}
            lang={edition.locale.slice(0, 2).toLowerCase()}
            href={edition.link}
            className="editions-menu__list__item yr-track"
            onClick={this.handleCET}
            {...cetData}
          >
            {edition.name}
          </a>
        ));
    });

    /* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus */
    return (
      <div className={className}>
        <div
          className="editions-menu__list"
        >
          {
          (selectable ? (
            <>
              <div
                onClick={this.handleToggleOptions}
                className="editions-menu__selectable-handler"
              >
                <IndicatorIcon viewBox="0 0 10 6" className="editions-menu__selectable-indicator" />
                <FormattedMessage id="EDITIONS_MENU_LABEL" values={{ editionName: editionsList.shift() }} />
              </div>
              <div
                className="editions-menu__options"
                style={{ display: (selectable && showOptions) ? 'block' : 'none' }}
                onMouseLeave={() => this.setState({ showOptions: false })}
              >
                {editionsList}
              </div>
            </>
          ) : editionsList)
        }
        </div>
      </div>
    );
    /* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus */
  }
}

EditionsMenu.propTypes = {
  modifiers: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default EditionsMenu;
